import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ReportUser.css';

import ReportManagement from '../../../components/siteadmin/ReportManagement';

const ReportUser = () => {

    const [state, setState] = useState({ currentPage: 1, searchList: '' });

    const setStateVariable = (variables) => {
        setState(prev => ({
            ...prev,
            ...variables
        }));
    };

    return <ReportManagement
        currentPage={state?.currentPage}
        searchList={state?.searchList}
        setStateVariable={setStateVariable}
    />
}

export default compose(withStyles(s))(ReportUser);
